import { getStepsArr } from "./steps";
import Driver from "driver.js";
import "driver.js/dist/driver.min.css";
import { computed, h, onMounted, watch } from "vue";
import { useStore } from "vuex";
import commonApi from "@/api/common/commonApi";
import { ElMessageBox } from "element-plus";
// import useManage from "../power/useManage";
import { useRoute } from "vue-router";

import guide from "@/assets/old_guide.png";

export default () => {
  let driver: Driver;
  const store = useStore();
  const route = useRoute();

  onMounted(() => {
    initDriver();
  });

  const initDriver = () => {
    driver = new Driver({
      animate: true, // Whether to animate or not
      opacity: 0.75, // Background opacity (0 means only popovers and without overlay)
      padding: 5, // Distance of element from around the edges
      allowClose: false, // Whether the click on overlay should close or not
      overlayClickNext: false, // Whether the click on overlay should move next
      doneBtnText: "结束", // Text on the final button
      closeBtnText: "取消引导", // Text on the close button for this step
      nextBtnText: "下一步", // Next button text for this step
      prevBtnText: "上一步", // Previous button text for this step
      onReset: async () => {
        document.getElementById("guideCloseNotice")?.click();
        // 引导结束
        const userinfo = store.getters.getUserinfo();
        // useManage(userinfo.userid);
        userinfo.isFirstLogin = false;
        store.commit("SET_USERINFO", userinfo);
        await editAgentUser();
      },
      onHighlightStarted: (e: Driver.Element) => {
        const el = document.getElementById("guideBtn");
        const node = e.getNode() as any;
        const classList = node.classList || [];
        console.log(classList);
        if (classList.contains("guideNotice")) {
          el?.classList.add("guide");
        } else el?.classList.remove("guide");
        console.log(el, e);
      },
    });
  };
  const editAgentUser = async () => {
    await commonApi.editAgentUser();
  };
  // 使用
  const handleGuide = (bol = false) => {
    document.getElementById("guideClickNotice")?.click();
    const { isManager, isPlatform } = store.getters.getUserinfo();
    driver.defineSteps(getStepsArr(isManager, isPlatform, bol));
    driver.start();
  };

  const userinfo = computed(() => store.getters.getUserinfo());
  const tagList = computed(() => store.getters.getTagList);
  const unwatch = watch([userinfo, tagList], ([userinfo, tagList]) => {
    if (userinfo.isFirstLogin && userinfo.isPlatform && tagList?.length && route.name != "manage" && String(route.name).indexOf("Customer") <= -1) {
      confirm(userinfo.uVersion == "1.0");
    } else if (!userinfo.isFirstLogin) unwatch();
  });

  const confirm = (isOld = false) => {
    unwatch();
    message(isOld)
      .then(() => {
        handleGuide();
      })
      .catch(() => {
        handleGuide(true);
      });
  };

  const message = (isOld = false) => {
    if (isOld) {
      return ElMessageBox({
        title: "",
        customClass: "message_blank", // 空白样式
        closeOnClickModal: false,
        message: h("img", {
          src: guide,
          style: {
            width: "100%",
            display: "block",
            cursor: "pointer",
          },
          onclick: () => {
            ElMessageBox.close();
            handleGuide();
          },
        }),
      });
    } else
      return ElMessageBox.confirm("欢迎进入 财务大管家，下面即将进入 新手引导；", {
        confirmButtonText: "开始引导",
        cancelButtonText: "取消引导",
        closeOnClickModal: false,
      });
  };
  return { handleGuide };
};
